import type { JSX } from 'react';

import { Card } from '@change-corgi/design-system-legacy/components/content';

import { ExportPetitionForm } from './components/ExportPetitionForm';
import { RecentSupportersList } from './components/RecentSupportersList';

export function RecentSupporters(): JSX.Element {
	return (
		<Card
			mt="16px"
			backgroundColor="white"
			sx={{ border: 'unset', display: 'flex', flexDirection: 'column', borderRadius: 'big' }}
		>
			<RecentSupportersList />
			<ExportPetitionForm />
		</Card>
	);
}
